import { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from './userContext';
import { getToken, getSessionData, clearSession } from './sessionManager';

const PROTECTED_ROUTES = ['/ajoutAnnonce', '/showAnnonce', '/showStatistique', '/showPayment', '/showGoChat', '/chat', '/profil'];

function useUserSession() {
  const { user, setUser, loading, setLoading, nbnotif, setNbnotif } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Restaurer la session locale une seule fois au montage
  useEffect(() => {
    if (!user) {
      const sessionData = getSessionData();
      if (sessionData) {
        setUser(sessionData);
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Redirige si le token est invalide/expiré sur les routes protégées
  useEffect(() => {
    const token = getToken();
    const isProtectedRoute = PROTECTED_ROUTES.some(route => location.pathname.startsWith(route));
    if (!loading && !token && isProtectedRoute) {
      clearSession();
      setUser(null);
      navigate('/');
    }
  }, [loading, user, location, navigate, setUser]);

  return { user, loading, setUser, nbnotif, setNbnotif, setLoading };
}

export default useUserSession;